import TablesController from './tables_controller'
import $ from 'jquery'

export default class extends TablesController
  @targets: ['package', 'problemSet', 'school', 'course', 'projects', 'form',
             'search', 'table', 'count', 'button', 'noReply']

  # Store initial value of projects selector
  initialize: -> $(@projectsTarget).prop 'previous', $(@projectsTarget).val() if @hasProjectsTarget

  # Initial filtering
  tableTargetConnected: (table) -> @connectFilterTable(table)

  textInParens: /\((?<text>.+)\)/

  # Toggle problem list problem set
  toggleProblemSet: -> $(@problemSetTarget).val ''

  # Toggle problem list package
  togglePackage: ->
    if $(@problemSetTarget).val()
      package_text = $(@problemSetTarget).find('option:selected').text().match(@textInParens).groups.text
      $(@packageTarget).val $(@packageTarget).find("option:contains('#{package_text}')").val()

  # Toggle student list class
  toggleCourse: -> $(@courseTarget).val '' if @hasCourseTarget

  # Toggle student list school
  toggleSchool: ->
    if $(@courseTarget).val()
      school_text = $(@courseTarget).find('option:selected').text().match(@textInParens).groups.text
      $(@schoolTarget).val $(@schoolTarget).find("option:contains('#{school_text}')").val()

  # Toggle user list projects
  toggleProjects: (event) ->
    developer = /Administrator|Experimenter|Developer/.test $(event.target).find('option:selected').text()
    $(@projectsTarget).val [] unless developer
    $(@projectsTarget).prop 'disabled', not developer

  # Filter user projects so lower subprojects are disjoint from higher ones
  filterProjects: (event) ->
    if (current = $(@projectsTarget).val().find (value) => !$(@projectsTarget).prop('previous').includes(value))?
      $(@projectsTarget).val $(@projectsTarget).val().filter (value) =>
        value is current or not value.startsWith(current) and not current.startsWith(value)
    $(@projectsTarget).prop 'previous', $(@projectsTarget).val()

  # Select a folder and send path to search form
  selectFolder: (event) ->
    # console.log('selectFolder', event)
    deselect = event.ctrlKey || event.metaKey
    $(@formTarget).find('[id$="path"]').val if deselect then '' else event.params.path
    $(event.target).closest('.table').find('.tr').removeClass('selected')
    $(event.target).closest('.tr').addClass('selected') unless deselect
    # event.stopPropagation()

  # Reset tables
  resetTable: (event) ->
    # console.log('resetTable', event)
    $filters = $(@formTarget).find '.filters'
    $filters.find('select').val -> $(@).find('option').val()
    $filters.find('input').val -> $(@).data('date') or null
    unless $filters.find('select').length then @filterTable(event) else @searchTable(event)
    event.preventDefault()

  # Search tables with server request
  searchTable: (event) ->
    # console.log('searchTable', event)
    unless @hasSearchTarget and @searchTargets.includes event.target
      if @hasButtonTarget
        $(@buttonTarget).click()
      else
        Rails.fire @formTarget, 'submit'

  # Filter tables locally based on search text on connect
  connectFilterTable: (tableTarget) ->
    # console.log('connectFilterTable', @searchTargets)
    if @hasSearchTarget
      item = $(tableTarget).closest('section.list').prev().find('input[type="search"]')[0]
      searchTarget = if @searchTargets.length == 1 then @searchTarget \
                     else @searchTargets.find (target) => target == item
      @filterTableRows searchTarget, tableTarget

  # Filter tables locally based on search text on type event
  filterTable: (event) ->
    # console.log('filterTable', event)
    if @hasSearchTarget && event.type in ['input', 'click']
      item = $(event.target).closest('.top').next().find('.table .tbody')[0]
      tableTarget = if @tableTargets.length == 1 then @tableTarget \
                    else @tableTargets.find (target) => target == item
      @filterTableRows event.target, tableTarget
      @sendNoReply @formTarget, @noReplyTarget

  filterTableRows: (searchTarget, tableTarget) ->
    # console.log('filterTableRows', searchTarget, tableTarget)
    terms = $(searchTarget).val().toLowerCase().split(' ').compact()
    $(tableTarget).find('.tr').each ->
      text = $(@).find('.td.filter').text().toLowerCase()
      $(@).toggleClass 'filtered', terms.some((term) -> not text.includes(term))
    if ($countTarget = $(tableTarget).next('.tfoot').find('.td.count')).length
      $countTarget.text $(tableTarget).find('.tr').not('.filtered').length
    @reshadeRows tableTarget
